const FocusPageId = {
    selectedId : "",


};

export default FocusPageId;


// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/FocusPageId.js